import type { ReactNode } from 'react';

import { isMobileWebview } from 'helpers/isMobileWebview';

export interface MobileAwareWebsiteLinkProps {
  url: string;
  children: ReactNode;
}

export function MobileAwareWebsiteLink({ url, children }: MobileAwareWebsiteLinkProps) {
  if (isMobileWebview()) {
    return (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          window.ReactNativeWebView?.postMessage(`webview:${url}`);
          window.postMessage(`webview:${url}`, '*');
        }}
      >
        {children}
      </a>
    );
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
